import React, { useState, useEffect, useRef } from "react";
import Video from '../../Assets/images/burns.mp4';
import './styles.scss'

const Hero = () => {
    const heroContainer = useRef(null);

    const [loaded, setLoaded] = useState(false)
    const [position, setPosition] = useState(0)

    useEffect(() => {
        setPosition((window.innerHeight - 75) / 2)
        document.addEventListener("scroll", scrollHandler);
    }, []);

    const scrollHandler = () => {
        let heroBottom = heroContainer.current.getBoundingClientRect().bottom;
        setPosition(heroBottom / 2)
    };

    return(
        <div ref={heroContainer} className={`hero ${loaded ? 'loaded' : ''}`}>
            <h1 style={{ bottom: `${position}px` }}>Jeremy Charles Burns</h1>
            <video autoPlay muted loop>
                <source src={ Video } type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    )
}
export default Hero;